export const CATALOG_CAMPAIGN_NAME = 'Catalog Campaigns';
